<template>
  <base-card head="meters" class="h-full">
    <template #action>
      <base-button-icon
        @click="$emit('refresh')"
        :loading="fetching"
        size="sm"
        icon="refresh"
        class="text-primary"
      >
      </base-button-icon>
    </template>
    <base-loader v-if="fetching" :fetching="fetching" />
    <template v-else-if="meters.length > 0">
      <base-input v-model.trim="searchMeter" size="sm" class="relative" label="meter_search">
        <template #append>
          <div class="absolute right-0 v-align mr-2">
            <base-icon
              v-if="searchMeter.length === 0"
              class="lg:mt-4 text-2xl text-secondary-dark"
              icon="search"
            />
            <button v-else @click="searchMeter = ''" class="sm:mt-5 text-xl" type="button">
              <base-icon icon="close" />
            </button>
          </div>
        </template>
      </base-input>
      <div
        :class="[
          'flex flex-col px-1  overflow-auto',
          $store.getters['companies/list'].length > 1 ? 'h-56' : 'h-72',
        ]"
      >
        <div
          v-for="(meter, i) in filteredMeters"
          :key="`${i}-${meter.meter_serial}`"
          class="py-1 flex items-center border-b"
        >
          <label class="flex items-center w-full leading-normal cursor-default">
            <input :value="meter" v-model="selectedMeter" type="radio" name="meter" />
            <div
              :class="[
                'ml-3 flex justify-between items-center text-sm px-2 py-1 w-full',
                meter.meter_serial === selectedMeter.meter_serial ? 'text-primary-light' : '',
              ]"
            >
              <div class="flex flex-col">
                <div class="text-sm font-bold">{{ meter.meter_serial }}</div>
                <div v-if="meter.mp_name" class="mt-1 text-xs opacity-75 flex items-center">
                  <base-icon icon="map-pin" class="mr-1 -ml-1 text-primary" />
                  <span v-if="meter.measuring_point_id" class="mr-1 font-semibold">
                    {{ meter.measuring_point_id }}
                  </span>
                  <span>{{ meter.mp_name }}</span>
                </div>
              </div>
              <div class="flex flex-col items-end text-xs opacity-75">
                <div class="text-primary">{{ meter.comd_type || meter.meter_type }}</div>
                <div class="mt-1 text-black">{{ meter.comd_serial }}</div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </template>
    <div v-else class="bg-white w-full text-sm text-center">
      <p class="p-2 m-12 font-semibold">
        {{ $t(`mygwf.components.User.ReportMeters.no_results`) }}
      </p>
    </div>
  </base-card>
</template>

<script>
import {BaseButtonIcon, BaseCard, BaseIcon, BaseInput, BaseLoader} from '@/components/base'

export default {
  data() {
    return {
      metersLoading: false,
      searchMeter: '',
    }
  },
  computed: {
    filteredMeters() {
      return this.meters.filter(
        meter =>
          (meter.meter_serial &&
            meter.meter_serial.toLowerCase().indexOf(this.searchMeter.toLowerCase()) !== -1) ||
          (meter.mp_name &&
            meter.mp_name.toLowerCase().indexOf(this.searchMeter.toLowerCase()) !== -1) ||
          (meter.measuring_point_id &&
            meter.measuring_point_id.toLowerCase().indexOf(this.searchMeter.toLowerCase()) !==
              -1) ||
          (meter.comd_serial &&
            meter.comd_serial.toLowerCase().indexOf(this.searchMeter.toLowerCase()) !== -1)
      )
    },
    selectedMeter: {
      get() {
        return this.value
      },
      set(n, o) {
        this.$emit('update', n)
      },
    },
  },
  model: {
    event: 'update',
  },
  props: {
    value: {
      type: [Object],
    },
    meters: {
      type: Array,
      required: true,
    },
    fetching: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BaseButtonIcon,
    BaseCard,
    BaseIcon,
    BaseInput,
    BaseLoader,
  },
}
</script>
